import { createApi } from "@reduxjs/toolkit/query/react";
import { encryptedBaseQueryWithReauth } from "../utilities/encryptedBaseQuery";

export const rolesApi = createApi({
  reducerPath: "rolesApi",
  baseQuery: encryptedBaseQueryWithReauth(process.env.REACT_APP_LOCAL_URL),
    tagTypes: ["getRoles", "getRoleById", "createRole", "updateRole", "updateRoleStatus", "deleteRole"],
    endpoints: (builder) => ({
        getRoles: builder.query({
            query: (endpoint) => `${endpoint}`,
            providesTags: ["getRoles"],
            method: "GET"
        }),
        getRoleById: builder.query({
            query: (endpoint) => `${endpoint}`,
            providesTags: ["getRoleById"],
        }),

        createRole: builder.mutation({
            query: ({ endpoint, data }) => {
                return {
                    url: endpoint,
                    method: "POST",
                    body: data,
                };
            },
            invalidatesTags: ["createRole"],
        }),

        updateRole: builder.mutation({
            query: ({ endpoint, updatedData }) => {
                return {
                    url: endpoint,
                    method: "PATCH",
                    body: updatedData,
                };
            },
            invalidatesTags: ["updateRole"],
        }),
        updateRoleStatus: builder.mutation({
            query: ({ endpoint, updatedData }) => {
                return {
                    url: endpoint,
                    method: "PATCH",
                    body: updatedData,
                };
            },
            invalidatesTags: ["updateRoleStatus"],
        }),
        deleteRole: builder.mutation({
            query: ({ endpoint }) => {
                return {
                    url: endpoint,
                    method: "DELETE",

                };
            },
            invalidatesTags: ["deleteRole"],
        }),
        getRolesData: builder.query({
            query: (endpoint) => `${endpoint}`,
        }),
    }),
});

export const {
    useCreateRoleMutation,
    useGetRolesQuery,
    useGetRolesDataQuery,
    useGetRoleByIdQuery,
    useUpdateRoleMutation,
    useUpdateRoleStatusMutation,
    useDeleteRoleMutation
} = rolesApi;
